// extracted by mini-css-extract-plugin
module.exports = {"dictionary-wrap":"dictionary-wrap___1CFGb","empty-view":"empty-view___2EC8s"};